<template>
  <!-- 对齐 App help.dart：AppHeader + 圆角 50 卡片 + FAQ 列表 + EmptyState（不要底部操作栏） -->
  <div class="help-page">
    <app-header :title="i18n.title"></app-header>

    <!-- App 端圆角 50 -->
    <div class="help-card-wrap">
      <div class="help-items" v-if="items.length > 0">
        <div v-for="(item, i) in items" :key="item.pid || i">
          <collapse-item
            v-if="item.pid"
            :item="item"
            :value="activeIndex === i"
            @input="onChange(i)"
          ></collapse-item>
          <div class="help-items-type" v-else>{{ item }}</div>
        </div>
      </div>
      <empty-state v-else-if="!loading" :text="i18n.no_data || 'No Data'"></empty-state>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { HELP_LIST } from "../../apis/user.js"
import CollapseItem from "../../components/help/collapse_item.vue"
import AppHeader from "../../components/common/AppHeader.vue"
import EmptyState from "../../components/common/EmptyState.vue"

export default {
  components: {
    CollapseItem,
    AppHeader,
    EmptyState
  },
  computed: {
    ...mapState(["lang"]),
    i18n() {
      return this.$t("help")
    }
  },
  data() {
    return {
      activeIndex: 0,
      loading: false,
      error: "",
      items: []
    }
  },
  methods: {
    onChange(i) {
      this.activeIndex = i
    },
    // 对齐 App getHelpList：cdb/mine/help/list，参数 classId=help_$lang-$country
    loadList() {
      this.loading = true
      const query = { classId: `help_${this.lang}` }
      this.$get(
        HELP_LIST,
        query,
        (resp) => {
          this.loading = false
          if (resp && resp.list) {
            this.error = ""
            this.items = resp.list || []
          } else {
            this.items = []
            this.error = this.i18n.msg_fail_content || "Request failed"
          }
        },
        (error) => {
          this.loading = false
          this.items = []
          this.error = error
        }
      )
    }
  },
  created() {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.help-page {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* App 端 help 卡片圆角 50 */
.help-card-wrap {
  flex: 1;
  background: #fff;
  border-radius: 50px 50px 0 0;
  margin-top: -16px;
  padding: 30px 0 0;
  box-sizing: border-box;
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.help-items {
  flex: 1;
  padding: 0 0 30px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.help-items-type {
  margin: 12px 22px 12px;
  font-size: 32px;
  font-weight: 600;
  color: #000;
}
</style>
